/*LIBRARY*/
import React, { useRef } from "react";
import { connect } from "react-redux";

/*COMPONENT*/

/*REDUX*/
import { uploadSquareLayer } from "../../App/actions/layerActions";

/*PICTURE*/

/*FUNCTION*/
import uuid from "../../App/validation/uuid";

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

const UploadBanner = ({ auth, layer, uploadSquareLayer }) => {
  const fileInput = useRef(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    const { geo_layer_wo_geojson } = layer;
    const file = fileInput.current.files[0];

    if (!file) return;

    const objParams = {
      file: file,
      file_name: "square_form_" + uuid(),
      dirname: "square_form",
    };

    const finalObject = {
      objParams,
      geo_layer_id: geo_layer_wo_geojson?.geo_layer?._id,
    };

    uploadSquareLayer(finalObject);
  };

  //local storage
  const language = localStorage?.language || auth.language;

  //local state

  //global props
  const { geo_layer_wo_geojson } = layer;

  let itemContent = (
    <label
      className="fileContainer"
      style={{
        backgroundImage: `url(${
          geo_layer_wo_geojson?.geo_layer?.picture_url_square
            ? geo_layer_wo_geojson?.geo_layer?.picture_url_square[0]?.url
            : ""
        })`,
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundColor: "#dedede",
        width: "100%",
        paddingBottom: "100%",
        borderRadius: "10px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: "20px",
          backgroundColor: "#fff",
          color: "#000",
          borderRadius: "2rem",
          padding: "5px 10px 5px 10px",
          boxShadow: "0 0 6px #9d9d9d53",
        }}
      >
        {dict["Click to change the square banner (ratio 1 : 1)"][language]}
      </div>
      <input
        style={{ cursor: "pointer" }}
        type="file"
        accept="image/*"
        ref={fileInput}
        onChange={handleSubmit}
        data-mapid="uploadRatio-1"
      />
    </label>
  );

  return <div>{itemContent}</div>;
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  layer: state.layer,
});

export default connect(mapStateToProps, {
  uploadSquareLayer,
})(UploadBanner);
